import { render } from "./CopyFilePopup.vue?vue&type=template&id=01990384"
import script from "./CopyFilePopup.vue?vue&type=script&lang=js"
export * from "./CopyFilePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__